import logo from "./logo.svg";
import "./App.css";
import React, { lazy, Suspense, useEffect, useState } from "react";
import "./config";
import $ from "jquery";
import axios from "axios";
import { BrowserRouter, Routes ,Route } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactSession } from "react-client-session";
import { gapi } from "gapi-script";
import { isMobile } from "react-device-detect";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import LoginPage from "./themes/sampanganimation/LoginPage";
import RegisterPage from "./themes/sampanganimation/RegisterPage";
import MySecretPage from "./themes/sampanganimation/mysecret/MySecret";
import UpdateMySecretPage from "./themes/sampanganimation/mysecret/Update";
import AddMySecretPage from "./themes/sampanganimation/mysecret/Add";
import InstallPrompt from "./InstallPrompt";
import LoadingPage from "./themes/sampanganimation/Loading";
// import { useOtpPushListener } from "./hooks/useOtpPushListener";

// const loader = document.querySelector("#preloader");
const loader = document.querySelector("body");

// if you want to show the loader when React loads data again
// const showLoader = () => loader.classList.remove("loader--hide");

// const hideLoader = () => loader.classList.add("loader--hide");
const hideLoader = () => null;

function App() {
  const [themes, setThemes] = useState("");
  ReactSession.setStoreType("localStorage");

  // Cuma "dengerin" — gak daftarin device apapun di halaman ini
  // const notification = useOtpPushListener(true);

  useEffect(() => {
    const icon = document.querySelector('link[rel="icon"]');

    // var endoceImg = `${global.config.backend}/api/getimage/${base64_encode('./themes/sampang/img/backgroud/8844b038c1ba61ff4956f419d417f7c9.jpg')}`;
    // console.log(endoceImg);

    gapi.load("client:auth2", () => {
      gapi.client.init({
        clientId:
          "203471354608-gognnrj3fe89bi5hf5451rplevpuil2s.apps.googleusercontent.com",
        scope: "",
      });
    });

    axios
      .get(global.config.host + "/themes")
      .then((res) => {
        if (res.data.status == "success") {
          $("title").html(res.data.title);

          global.config.theme = res.data.theme;
          global.config.title = res.data.title;
          global.config.backend = global.config.host + "/" + res.data.theme;

          icon.setAttribute(
            "href",
            global.config.backend +
              "/api/getimage/" +
              "L2Fzc2V0cy9pbWcvbG9nby5wbmc="
          );
          const HeaderLazy = React.lazy(() =>
            import("./themes/" + res.data.theme + "/Header.js")
          );
          const FooterLazy = React.lazy(() =>
            import("./themes/" + res.data.theme + "/Footer.js")
          );
          const ContentLazy = React.lazy(() =>
            import("./themes/" + res.data.theme + "/Content.js")
          );

          setThemes(
            <>
              <InstallPrompt />
              <Suspense fallback={<LoadingPage />}>
                <BrowserRouter>
                  <Routes>
                    <Route path="/sayahariini" element={<LoginPage hideloader={hideLoader} />} />
                    <Route path="/register" element={<RegisterPage hideloader={hideLoader} />} />
                    <Route path="/mysecret" element={<MySecretPage hideloader={hideLoader} />} />
                    <Route path="/mysecret/request-update" element={<UpdateMySecretPage hideloader={hideLoader} />} />
                    <Route path="/mysecret/add" element={<AddMySecretPage hideloader={hideLoader} />} />
                    <Route
                      path="*"
                      element={
                        <>
                          <HeaderLazy hideloader={hideLoader} />
                          <ContentLazy />
                          <FooterLazy theme={res.data.theme} />
                        </>
                      }
                    />
                  </Routes>
                </BrowserRouter>
              </Suspense>
            </>
          );
        } else {
          alert("Error get data from backend !!");
          loader.classList.add("loader--hide");
        }
      })
      .catch((res) => {
        console.log(res);
        loader.classList.add("loader--hide");
        Swal.fire({
          title: "Error Connect",
          text: "Error connect to services",
          icon: "warning",
        });
      });
  }, []);

  return <>{themes}</>;
}

export default App;
